<div
  class="coachbot-all-antipattern-popup-content"
  id="feedback-form"
  *ngIf="isFeedbackStageForm"
>
  <h1 translate>antipattern.feedback.labels.description</h1>
  <div [class]="getBannerClass()" [style]="getBannerStyle()">
    <img
      *ngIf="isAntipatternDetected"
      src="{{ assetsPath$ | async }}/icons/warning-icon.svg"
      height="auto"
      width="auto"
    />
    <span>{{ configuration?.name }}</span>
  </div>
  <div
    class="coachbot-all-antipattern-popup-description_text"
    [innerHTML]="processedDescription"
  ></div>
  <h1 translate>antipattern.feedback.labels.was_this_helpful</h1>
  <div
    id="feedback-form-like"
    class="coachbot-antipattern-popup-banner"
    style="
      background: rgba(223, 246, 229, 1);
      border: 1px solid rgba(63, 167, 80, 1);
      color: rgba(63, 167, 80, 1);
    "
    *ngIf="feedback"
  >
    <img
      src="https://alpha-coach-bot-students-assets.s3.amazonaws.com/icons/thumbs_up-sm.svg"
      width="16"
      height="16"
      alt="Success"
    />
    <span translate>antipattern.feedback.labels.yes</span>
  </div>
  <div
    id="feedback-form-dislike"
    class="coachbot-antipattern-popup-banner"
    style="
      background: rgba(255, 224, 219, 1);
      border: 1px solid rgba(227, 82, 74, 1);
      color: rgba(227, 82, 74, 1);
    "
    *ngIf="!feedback"
  >
    <img
      src="https://alpha-coach-bot-students-assets.s3.amazonaws.com/icons/thumbs_down-sm.svg"
      width="16"
      height="16"
      alt="Success"
    />
    <span translate>antipattern.feedback.labels.no</span>
  </div>
  <h1 translate>antipattern.feedback.labels.add_comment</h1>
  <textarea
    id="feedback-input"
    name="note"
    placeholder="{{ 'antipattern.feedback.labels.feedback_input' | translate }}"
    [disabled]="feedbackSent"
    [(ngModel)]="note"
  ></textarea>
</div>
<div class="coachbot-all-antipattern-popup-feedback">
  <ng-container [ngSwitch]="stage">
    <ng-container *ngSwitchCase="FeedbackStages.Initial">
      <div class="coachbot-all-antipattern-popup-feedback-content" id="feedback-init">
        <div translate>antipattern.feedback.labels.was_this_helpful</div>
        <div class="feedback-action">
          <button
            id="feedback-like"
            class="feedback-like"
            [style.background-image]="
              'url(' + (assetsPath$ | async) + '/icons/thumbs_up.svg)'
            "
            (click)="onFeedbackClick(true)"
          ></button>
          <button
            id="feedback-dislike"
            data-value="false"
            class="feedback-dislike"
            [style.background-image]="
              'url(' + (assetsPath$ | async) + '/icons/thumbs_down.svg)'
            "
            (click)="onFeedbackClick(false)"
          ></button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="FeedbackStages.Confirmation">
      <div class="coachbot-all-antipattern-popup-feedback-content" id="feedback-request">
        <div translate>antipattern.feedback.labels.feedback_send_confirmation</div>
        <div class="feedback-action">
          <a id="feedback-request-comment" (click)="onAddCommentClick()" translate>antipattern.feedback.actions.add_comment</a>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="FeedbackStages.Form">
      <div class="coachbot-all-antipattern-popup-feedback-content" id="feedback-action">
        <div id="feedback-status" class="action-status" *ngIf="feedbackSent">
          <img
            src="{{ assetsPath$ | async }}/icons/check_circle.svg"
            width="24"
            height="24"
            alt="Success"
          />
          {{ 'antipattern.feedback.labels.comment_saved' | translate }}
        </div>
        <div class="feedback-action">
          <button
            id="feedback-send"
            class="feedback-action-fill"
            [disabled]="note.trim().length === 0 || feedbackSent"
            (click)="onSaveCommmentClick()"
            translate
          >
            antipattern.feedback.actions.save_comment
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
